// extracted by mini-css-extract-plugin
export var brand = "_36-9";
export var button = "_36-0";
export var chevron = "_36-v";
export var chevronButton = "_36-w";
export var content = "_36-n";
export var danger = "_36-g";
export var dangerOutlined = "_36-h";
export var dark = "_36-l";
export var darkTheme = "_36-c";
export var extraSmall = "_36-4";
export var fullWidth = "_36-8";
export var ghost = "_36-d";
export var gray = "_36-t";
export var icon = "_36-p";
export var iconButton = "_36-s";
export var iconButtonBorder = "_36-x";
export var iconButtonBorderDark = "_36-y";
export var iconButtonBorderLight = "_36-z";
export var iconLeft = "_36-q";
export var iconRight = "_36-r";
export var large = "_36-1";
export var light = "_36-m";
export var medium = "_36-2";
export var micro = "_36-5";
export var nano = "_36-7";
export var outlined = "_36-k";
export var pending = "_36-a";
export var primary = "_36-i";
export var shadow = "_36-o";
export var small = "_36-3";
export var solidLight = "_36-e";
export var solidLightBrand = "_36-f";
export var spinner = "_36-u";
export var transparent = "_36-j";
export var warning = "_36-b";
export var wideNano = "_36-6";